import { QuickAddProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddProps";
import {
  IQuickAddEventParams,
  QuickAddTrackingEventsContextBaseProvider,
} from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddTrackingEventsContext/__internal__/QuickAddTrackingEventsProviders/QuickAddTrackingEventsContextBaseProvider";
import { useGetCartItemToken } from "@faire/retailer-visitor-shared/views/brand/BrandCart/hooks/useGetCartItemToken";
import { useOptimisticBrandCartUpdate } from "@faire/retailer-visitor-shared/views/brand/BrandCart/hooks/useOptimisticBrandCartUpdate";
import { ICartItemV2 } from "@faire/web-api--source/faire/carts/ICartItemV2";
import React, { useCallback } from "react";

export const BrandPageQuickAddTrackingEventsContextProvider = ({
  data,
  children,
}: {
  data: QuickAddProps;
  children: React.ReactNode;
}) => {
  const { addBrandCartItems } = useOptimisticBrandCartUpdate(
    data.brandToken ?? ""
  );
  const findCartItemToken = useGetCartItemToken(data.brandToken ?? "");

  const onQuickAddClick = useCallback(
    ({ newQuantity }: IQuickAddEventParams) => {
      addBrandCartItems([
        ICartItemV2.build({
          name: data.productName,
          image: data.productImage,
          product_token: data.productToken,
          product_option_token: data.quickAdd?.quick_add_option?.option_token,
          quantity: newQuantity,
        }),
      ]);
    },
    [
      data.productName,
      data.productImage,
      data.productToken,
      addBrandCartItems,
      data.quickAdd?.quick_add_option?.option_token,
    ]
  );
  return (
    <QuickAddTrackingEventsContextBaseProvider
      data={data}
      onQuickAddButtonClick={onQuickAddClick}
      getCartItemTokenByProductToken={findCartItemToken}
    >
      {children}
    </QuickAddTrackingEventsContextBaseProvider>
  );
};
